import clsx from "clsx"
import { ComponentProps, useRef } from "react"
import { ChevronUpDownIcon, Spinner } from "src/components/icons"

export type NativeSelectProps = {
  placeholder?: string
  errors?: Record<string, unknown>
  touched?: Record<string, unknown>
  loading?: boolean
} & ComponentProps<"select">

export const NativeSelect = ({
  placeholder = "Select...",
  defaultValue,
  disabled,
  loading,
  className,
  children,
  ...props
}: NativeSelectProps) => {
  const ref = useRef<HTMLSelectElement>(null)

  const Icon = loading ? Spinner : ChevronUpDownIcon

  return (
    <div className="relative h-11">
      <select
        ref={ref}
        defaultValue={defaultValue}
        disabled={disabled || loading}
        {...props}
        className={clsx(
          className,
          "size-full appearance-none rounded-3xl border bg-gray-50 px-4 pr-12 text-sm font-normal outline-hidden transition-colors duration-150",
          {
            "hover:bg-gray-100": !disabled,
          },
        )}
      >
        <option value="" className="text-muted">
          {placeholder}
        </option>

        {children}
      </select>

      <Icon
        className={clsx(
          "pointer-events-none absolute inset-y-0 right-4 flex h-full items-center",
          disabled && "opacity-50",
        )}
      />
    </div>
  )
}
